import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNavSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full whitespace-nowrap">
            分类浏览
          </span>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mt-3">
            探索你喜欢的漫画类型
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-xl mx-auto">
            八大分类，两千余部韩漫，总有一类适合你的口味
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-lg p-5 flex flex-col items-center text-center transition-all duration-300 hover:scale-[1.03] cursor-pointer border border-background-200/50 hover:border-primary-300/50"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-100 group-hover:bg-primary-200 transition-colors duration-300">
                <i className={`${cat.icon} text-xl text-primary-500`}></i>
              </div>
              <h3 className="mt-3 text-sm font-semibold text-foreground-900 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 mt-1 line-clamp-2">
                {cat.description}
              </p>
              <span className="mt-2 text-xs text-primary-500 font-medium whitespace-nowrap">
                {cat.count}部作品
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}